// import React, { useState } from "react";
import React, { useState, useEffect } from "react";
// import { NavLink } from "react-router-dom";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import FormContactUs from "../Pages/formContactUs";
// import WhatsappIcon from "../PicsForPages/WhatsappIcon1.png";

const getHref = (type, value) => {
  switch (type) {
    case "email":
      return `mailto:${value}`;
    case "phone":
      return `tel:${value}`;
    case "map":
      return `https://www.google.com/maps?q=${encodeURIComponent(value)}`;
    default:
      return "#";
  }
};

const contactInfo = [
  {
    label: "Email:",
    value: "info@corneliuswoods.net",
    type: "email",
  },
  {
    label: "Call Us:",
    value: "+18886220033",
    display: "(888) 622-0033",
    type: "phone",
  },
  {
    label: "Address:",
    value: "19181 Zion Ave, Cornelius, NC 28031",
    type: "map",
  },
];

function Footer() {
  const [isFreeQuoteVisible, setIsFreeQuoteVisible] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const openContactForm = () => {
    setIsFreeQuoteVisible(true);

    if (location.pathname !== "/getintouch") {
      navigate("/getintouch");
    }
  };

  // const hideFormContactUs = () => {
  //   setIsFreeQuoteVisible(false);
  // };

  const hideFormContactUs = () => {
    setIsFreeQuoteVisible(false);

    if (location.pathname === "/getintouch") {
      // navigate(-1); // go back to previous page
      navigate("/", { replace: true });
    }
  };

  // const handleOutsideClick = (event) => {
  //   if (event.target.classList.contains("FormContactUsParent")) {
  //     hideFormContactUs();
  //   }
  // };

  useEffect(() => {
    if (location.pathname === "/getintouch") {
      setIsFreeQuoteVisible(true);
    } else {
      setIsFreeQuoteVisible(false);
    }
  }, [location.pathname]);

  return (
    <div className="footerParent">
      <div className="footerBox">
        <div className="footerBoxTop">
          <div className="footerBoxTopBox">
            <div className="footerBoxTopBoxLeft">
              <span className="footerBoxTopBoxLeftBox">
                <span className="footerBoxTopBoxLeftBoxHeading">
                  Cornelius Woods
                </span>
                <span className="footerBoxTopBoxLeftBoxPara">
                  {/* A trusted name in 55+ active adult retirement living. Our
                  welcoming community offers upscale condos, engaging
                  activities, and a serene setting. Embrace new beginnings and
                  enriching experiences, surrounded by like-minded neighbors and
                  a dedicated staff. Discover the joys of retirement living at
                  Cornelius Woods in Cornelius, NC, where luxury, comfort, and
                  fulfillment await. */}
                  A trusted name in 55+ living, Cornelius Woods offers upscale
                  condominiums, thoughtfully planned shared spaces, and a serene
                  setting. Enjoy a lifestyle designed around quality, ease, and
                  everyday enjoyment in Cornelius, North Carolina.
                </span>
                <div className=" FooterTopParentMobileView">
                  {/* <span className="headerTopBoxRightMobileView">
                      <span className="headerTopBoxRightBoxMobileView">
                        <span className="headerTopBoxRightBoxSections">
                          <span className="headerTopBoxRightBoxSectionLabel">
                            Email:
                          </span>
                          <span className="headerTopBoxRightBoxSectionInput">
                            info@corneliuswoods.net
                          </span>
                        </span>

                        <span className="headerTopBoxRightBoxSections">
                          <span className="headerTopBoxRightBoxSectionLabel">
                            Call Us:
                          </span>
                          <span className="headerTopBoxRightBoxSectionInput">
                            888.622.0033
                          </span>
                        </span>

                        <span className="headerTopBoxRightBoxSections">
                          <span className="headerTopBoxRightBoxSectionLabel">
                            Address:
                          </span>
                          <span className="headerTopBoxRightBoxSectionInput">
                            19181 Zion Ave, Cornelius, NC 28031
                          </span>
                        </span>
                      </span>
                    </span> */}
                  <b className="FooterTopBoxRightMobileView">
                    {contactInfo.map((item, index) => (
                      <span
                        className="headerTopBoxRightBoxSections00"
                        key={index}
                      >
                        <span className="headerTopBoxRightBoxSectionLabel">
                          {item.label}
                        </span>

                        <a
                          href={getHref(item.type, item.value)}
                          className="headerTopBoxRightBoxSectionInput"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span>{item.display || item.value} </span>
                        </a>
                      </span>
                    ))}
                  </b>
                </div>
              </span>
            </div>

            <div className="footerBoxTopBoxRight">
              <span className="footerBoxTopBoxRightBox">
                <span className="footerBoxTopBoxRightBoxLeftSide">
                  <span className="footerBoxTopBoxRightBoxLeftSideBox">
                    <span className="footerBoxTopBoxRightBoxLeftSideBoxList">
                      <NavLink
                        to="/floorplans"
                        onClick={scrollToTop}
                        className={({ isActive }) =>
                          isActive
                            ? "headerBottomBoxRightBoxListLink activeLink"
                            : "headerBottomBoxRightBoxListLink"
                        }
                      >
                        Floorplans
                      </NavLink>
                    </span>

                    <span className="footerBoxTopBoxRightBoxLeftSideBoxList">
                      <NavLink
                        to="/amenities"
                        onClick={scrollToTop}
                        className={({ isActive }) =>
                          isActive
                            ? "headerBottomBoxRightBoxListLink activeLink"
                            : "headerBottomBoxRightBoxListLink"
                        }
                      >
                        Amenities
                      </NavLink>
                    </span>

                    <span className="footerBoxTopBoxRightBoxLeftSideBoxList">
                      <NavLink
                        to="/local-information"
                        onClick={scrollToTop}
                        className={({ isActive }) =>
                          isActive
                            ? "headerBottomBoxRightBoxListLink activeLink"
                            : "headerBottomBoxRightBoxListLink"
                        }
                      >
                        Local Information
                      </NavLink>
                    </span>

                    <span className="footerBoxTopBoxRightBoxLeftSideBoxList">
                      <NavLink
                        to="/about-us"
                        onClick={scrollToTop}
                        className={({ isActive }) =>
                          isActive
                            ? "headerBottomBoxRightBoxListLink activeLink"
                            : "headerBottomBoxRightBoxListLink"
                        }
                      >
                        About Us
                      </NavLink>
                    </span>
                  </span>
                </span>

                <span className="footerBoxTopBoxRightBoxRightSide">
                  <span className="footerBoxTopBoxRightBoxRightSideBox">
                    <span className="footerBoxTopBoxRightBoxRightSideList">
                      <NavLink
                        to="/privacy-policy"
                        onClick={scrollToTop}
                        className={({ isActive }) =>
                          isActive
                            ? "headerBottomBoxRightBoxListLink activeLink"
                            : "headerBottomBoxRightBoxListLink"
                        }
                      >
                        Privacy Policy
                      </NavLink>
                    </span>

                    <span className="footerBoxTopBoxRightBoxRightSideList">
                      <NavLink
                        to="/terms-conditions"
                        onClick={scrollToTop}
                        className={({ isActive }) =>
                          isActive
                            ? "headerBottomBoxRightBoxListLink activeLink"
                            : "headerBottomBoxRightBoxListLink"
                        }
                      >
                        Terms & Conditions
                      </NavLink>
                    </span>

                    {/* <span
                      className="footerBoxTopBoxRightBoxRightSideList"
                      onClick={() => setIsFreeQuoteVisible(true)}
                    >
                      Contact Us
                    </span> */}
                    <span
                      className="footerBoxTopBoxRightBoxRightSideList"
                      onClick={openContactForm}
                    >
                      Contact Us
                    </span>
                    <span className="">
                      <a
                        href="https://www.facebook.com/CorneliusWoodsActiveAdultCommunity/"
                        className="headerTopBoxRightBoxSectionInput"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-square-facebook footerBoxTopBoxRightBoxRightSideList"></i>
                      </a>
                      <a
                        href="https://www.linkedin.com/in/cornelius-woods-920a5a255/"
                        className="headerTopBoxRightBoxSectionInput"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-square-linkedin footerBoxTopBoxRightBoxRightSideList"></i>
                      </a>
                      <a
                        href="https://www.instagram.com/livingatcorneliuswoods/"
                        className="headerTopBoxRightBoxSectionInput"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-square-instagram footerBoxTopBoxRightBoxRightSideList"></i>
                      </a>
                      {/* <i className="fa-brands fa-square-x-twitter footerBoxTopBoxRightBoxRightSideList"></i> */}
                    </span>

                    {isFreeQuoteVisible && (
                      <div
                        className="FormContactUsParent"
                        // onClick={handleOutsideClick}
                      >
                        <div className="FormContactUsBox">
                          <FormContactUs />

                          <span
                            className="FormContactUsCloseButton"
                            onClick={hideFormContactUs}
                          >
                            <span>X</span>
                          </span>
                        </div>
                      </div>
                    )}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>

        <div className="footerBoxBottom">
          <div className="footerBoxBottomBox">
            <b className="footerBoxBottomBoxLeft">
              Powered by{" "}
              <a
                href="https://staiminds.com/"
                className="shushankTechLink"
                target="_blank"
                rel="noreferrer"
              >
                ST AI Minds
              </a>
            </b>

            <span className="footerBoxBottomBoxLeft">
              This site is protected by{" "}
              <a
                href="hhttps://staiminds.com/"
                className="shushankTechLink"
                target="_blank"
                rel="noreferrer"
              >
                ST AI Minds.{" "}
              </a>{" "}
              The <b>Privacy Policy</b> and <b>Terms of Service apply</b>.
            </span>
          </div>

          <div className="footerBoxBottomBox">
            <a
              href="https://www.linkedin.com/in/pandugayala-raja-naresh-b15b4986/"
              className="Developer"
              target="_blank"
              rel="noreferrer"
            >
              Crafted by: Pandugayala Raja Naresh | Web Developer
            </a>
          </div>
          {/* <div className="WhatApp">
            <a
              href="https://wa.link/l4a5mc"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img fetchPriority="high"
                  loading="eager"
                src={WhatsappIcon}
                alt="whatappIcon"
                className="whatappIcon"
              />
            </a>
          </div> */}

          <div className="goTop" onClick={scrollToTop}>
            ^
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
